/* eslint-disable */ 
import {useState } from "react";
import { Flex, Text, Icon, useColorModeValue, useToast } from '@chakra-ui/react'; 
import { TbFileInvoice } from 'react-icons/tb';

// Custom components   

import CommonDatatable from 'components/datatable/CommonDatatable';
import Actions from 'views/privado/servicesTracking/trackingBl/components/Actions';
import Header from 'views/privado/servicesTracking/trackingBl/components/Header';

import service from 'services/trackingBlService';

import { 
  createColumnHelper
} from '@tanstack/react-table'
  
type RowObj = {
	expbu: string;
    expbl: string;
    contenedor: string;
    buque: string;
    viaje: string;
    paisori: string;
    puertoori: string;
    paisdest: string;
    puertodest: string;
    fechaeta: Date;
    fechaeta_String: string;
    nombreconsiG1: string;
    nomnbreconsiG2: string;
    reG_SIDUENA: string;
    almacen: string;
    tamanO_CTR: string;
    tipO_CTR: string;
    usuariO_CREATE: string;
    fechA_CREATE: Date;
    fechA_CREATE_String: string;
    hiorA_CREATE: string;
    mostrarAlmacen: boolean;
    mostrarRegistro: boolean;
    labelFecha: string;
};

import { EXPORT_TITLE, EXPORT_DESCRIPTION } from "const/CommonConst";

export default function DataTable() {
	const textColor = useColorModeValue("navy.700", "white");

  const [tableData, setTableData] = useState([]);

  const [showEmptyState, setShowEmptyState] = useState(true);
  const [disabledActions, setDisabledActions] = useState(false);
  const [showProgressSearch, setShowProgressSearch] = useState(false);
  

  const fetchData = async (bl:string, contenedor:string) => {
    return bl !== '' ? await service.getTablaByBl(bl) : await service.getTablaByContenedor(contenedor);
  };

  const onChangeFilters = async (selected:any) => {
	try {
		setShowEmptyState(false);
	setDisabledActions(true);
	setShowProgressSearch(true);
	setTableData(await fetchData(selected.filtroBl, selected.filtrocontenedor));
}
  finally{
	setDisabledActions(false);
	setShowProgressSearch(false);
  }
  };

    const columnHelper = createColumnHelper<RowObj>();
 	const columns = [
		columnHelper.accessor('contenedor', {
			id: 'contenedor',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left' 
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					SIGLAS
				</Text>
			),
			cell: (info: any) => (
        <Text color={textColor} align='left' fontSize='md' fontWeight='500' >
            {info.getValue()}
        </Text>
			)
		}), 
		columnHelper.accessor('tamanO_CTR', {
			id: 'tamanO_CTR',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'					
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					TAMAÑO
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('tipO_CTR', {
			id: 'tipO_CTR',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					TIPO
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500' >
          {info.getValue()}
        </Text>
			)
		}),  
	];
	
  return ( 
    <CommonDatatable
    columnsDefinition={columns}
    tableData={tableData}
	showEmptyState={showEmptyState}
	isLoading={disabledActions}
    actionContent={    
        <Actions onChange={onChangeFilters} 
				 disabledActions={disabledActions} 
				 showProgressSearch={showProgressSearch} /> }
	headerContent={    
		<Header data={tableData && tableData.length > 0 ? tableData[0] : undefined} /> }
      />        
  )
} 
